import { Injectable } from '@angular/core';
import { HerdoutReason } from './herdout-reason';
import { HerdoutReasonSummary } from './herdout-reason-summary';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { firstValueFrom, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HerdoutReasonRepository {

    constructor(private readonly dbService: NgxIndexedDBService) { }

    public findByType(type: string): Promise<HerdoutReasonSummary[]> {
        const storeName = this.getStoreNameForType(type);

        if (!storeName) {
            return Promise.resolve([]);
        }

        const observable = this.dbService.getAll<HerdoutReason>(storeName).pipe(
            map(reasons => reasons.map(reason => HerdoutReasonSummary.fromJson(reason)))
        );

        return firstValueFrom(observable);
    }

    private getStoreNameForType(type: string): string | null {
        switch (type) {
            case 'herdOutByDeath':
                return 'deathReasons';
            case 'herdOutByDiscard':
                return 'discardReasons';
            case 'herdOutBySale':
                return 'saleReasons';
            default:
                console.warn(`Tipo de motivo inválido ou sem store mapeada: ${type}`);
                return null;
        }
    }
}
